import { MedicaidRejectionReasonCode } from "modules/medicaid/types";

export const REJECTION_REASON_OPTIONS: {
  value: MedicaidRejectionReasonCode;
  label: string;
}[] = [
  {
    value: MedicaidRejectionReasonCode.Eligibility_Not_Met,
    label: "Eligibility not met",
  },
  {
    value: MedicaidRejectionReasonCode.Insufficient_Information,
    label: "Insufficient information",
  },
  {
    value: MedicaidRejectionReasonCode.Conflict_Of_Interest,
    label: "Conflict of interest",
  },
  {
    value: MedicaidRejectionReasonCode.Out_Of_Jurisdiction,
    label: "Out of jurisdiction",
  },
  {
    value: MedicaidRejectionReasonCode.Service_Not_Offered,
    label: "Service not offered",
  },
  {
    value: MedicaidRejectionReasonCode.Client_Unresponsive,
    label: "Client unresponsive",
  },
  { value: MedicaidRejectionReasonCode.Other, label: "Other" },
];

export const getRejectionReasonLabel = (
  code?: string,
  clientSafeReason?: string,
) => {
  if (!code)
    return (
      clientSafeReason ||
      "The law firm you selected is not able to provide you with an Asset Protection Plan at this time."
    );

  if (code === MedicaidRejectionReasonCode.Other) {
    return clientSafeReason || "Other";
  }

  const found = REJECTION_REASON_OPTIONS.find(
    (option) => option.value === code,
  );

  return found?.label || code;
};
